<script setup lang="ts">
import type { ScrimLayer } from './scrim-types'

const props = withDefaults(
  defineProps<{
    /** Whether the scrim is showing. Fades in and out on change. */
    open: boolean
    /** Allow a click on the scrim to emit `close`. Off by default (a11y). */
    dismissible?: boolean
    /** Stacking layer: `modal` sits under a dialog panel, `raised` over one. */
    layer?: ScrimLayer
  }>(),
  { dismissible: false, layer: 'modal' },
)

const emit = defineEmits<{
  close: []
}>()

const LAYER_CLASS: Record<ScrimLayer, string> = {
  modal: 'z-40',
  raised: 'z-50',
}

function onClick() {
  if (props.dismissible) emit('close')
}
</script>

<template>
  <Transition enter-active-class="animate-fade-in" leave-active-class="animate-fade-out">
    <div
      v-if="open"
      aria-hidden="true"
      class="scrim-fallback fixed inset-0 bg-scrim backdrop-blur-scrim"
      :class="LAYER_CLASS[layer]"
      @click="onClick"
    />
  </Transition>
</template>
